import { ArrowTopRightOnSquareIcon } from '@heroicons/react/20/solid';
import { Link } from 'ui-components';

type Props = {
  mapUrl: string;
};

export function LocationLink({ mapUrl }: Props): React.ReactElement {
  return (
    <Link
      href={mapUrl}
      className="inline-flex gap-1 w-fit items-center"
      target="_blank"
      rel="noopener noreferrer"
    >
      Auf der Karte anzeigen
      <ArrowTopRightOnSquareIcon className="h-4" />
    </Link>
  );
}
